export default __webpack_public_path__ + "static/more-than-a-donut-shop-0ef4d063a7309236e3e7e8bbd28fa8de.png";